<template>
  <div class="page_box">
    <BaseBanner :bannerInfo.sync="bannerInfo"></BaseBanner>
    <BaseModule :moduleInfo.sync="moduleInfo1">
      <ul class="module_body module_body_1">
        <div class>{{list1.text}}</div>
        <img :class="`icon`" :src="cptLanguge=='en'? list1.img_en:list1.img" alt />
      </ul>
    </BaseModule>
    <BaseModule :moduleBg.sync="moduleBg" :moduleInfo.sync="moduleInfo2">
      <ul class="module_body module_body_2">
        <li class="module_item module_item_2" v-for="(item,index) in list2" :key="index+'_1'">
          <img :class="`icon_${index}`" :src="item.img" alt />
          <div class="module_item_text">
            <div class="module_item_text_title">{{item.title}}</div>
            <div>{{item.text1}}</div>
          </div>
        </li>
      </ul>
    </BaseModule>
    <BaseModule :moduleInfo.sync="moduleInfo3">
      <ul class="module_body flex module_body_3">
        <li class="module_item_3" v-for="(item,index) in list3" :key="index+'_3'">
          <div class>{{item.title}}</div>
          <img :src="cptLanguge=='en'?item.img_en:item.img" alt />
        </li>
      </ul>
    </BaseModule>
    <BaseModule :moduleBg.sync="moduleBg" :moduleInfo.sync="moduleInfo4">
      <ul class="module_body module_body_4">
        <div
          :class="`flex_center contact_us_body_email ${cptLanguge=='zh'?'contact_us_body_email_zh':''}`"
        >
          <!-- <img class="email_icon" src="./img/solve/icon7.png" alt=""> -->
          <p class="font_color_blue font_size_20">{{list4.text1}}</p>
          <p class="font_color_blue font_size_20">alex@qiditek.com</p>
        </div>
        <div
          :class="`flex_center contact_us_body_email ${cptLanguge=='zh'?'contact_us_body_email_zh':''}`"
        >
          <!-- <img class="email_icon" src="./img/solve/icon7.png" alt=""> -->
          <!--  <p class="font_color_blue font_size_20">{{list4.text2}}</p>
          <p class="font_color_blue font_size_20">khunpon@sh-mttek.com</p> -->
        </div>

        <!-- <li class="module_item_3" v-for="(item,index) in list3" :key="index+'_3'">
          <div class>{{item.title}}</div>
          <img :src="item.img" alt />
        </li>-->
      </ul>
    </BaseModule>
  </div>
</template>
<script>
export default {
  data() {
    return {
      moduleBg: true,
      bannerInfo: {
        img: require("@img/solve/banner.png"),
        desc: {
          title: this.$t("solve.bannerTitle"),
          text: this.$t("solve.text1"),
          text2: this.$t("solve.text2"),
        },
      },
      moduleInfo1: {
        title: this.$t("solve.module1.title"),
        desc: {
          text1: this.$t("solve.module1.titleDesc"),
        },
      },
      list1: {
        img: require("@img/solve/img1.png"),
        img_en:require("@img/solve/img1_en.png"),
        text: this.$t("solve.moduleList1.text1"),
      },
      moduleInfo2: {
        title: this.$t("solve.module2.title"),
        desc: {
          text1: "",
        },
      },
      list2: [
        {
          img: require("@img/solve/icon1.png"),
          title: this.$t("solve.moduleList2.title1"),
          text1: this.$t("solve.moduleList2.text1"),
        },
        {
          img: require("@img/solve/icon2.png"),
          title: this.$t("solve.moduleList2.title2"),
          text1: this.$t("solve.moduleList2.text2"),
        },
        {
          img: require("@img/solve/icon3.png"),
          title: this.$t("solve.moduleList2.title3"),
          text1: this.$t("solve.moduleList2.text3"),
        },
        {
          img: require("@img/solve/icon4.png"),
          title: this.$t("solve.moduleList2.title4"),
          text1: this.$t("solve.moduleList2.text4"),
        },
        {
          img: require("@img/solve/icon5.png"),
          title: this.$t("solve.moduleList2.title5"),
          text1: this.$t("solve.moduleList2.text5"),
        },
        {
          img: require("@img/solve/icon6.png"),
          title: this.$t("solve.moduleList2.title6"),
          text1: this.$t("solve.moduleList2.text6"),
        },
      ],
      moduleInfo3: {
        title: this.$t("solve.module3.title"),
        desc: {
          text1: "",
        },
      },
      list3: [
        {
          title: this.$t("solve.moduleList3.text1"),
          img: require("@img/solve/img2.png"),
          img_en: require("@img/solve/img2_en.png"),
        },
        {
          title: this.$t("solve.moduleList3.text2"),
          img: require("@img/solve/img3.png"),
          img_en: require("@img/solve/img3_en.png"),
        },
      ],
      moduleInfo4: {
        title: this.$t("solve.module4.title"),
        desc: {
          text1: this.$t("solve.module4.titleDesc"),
        },
      },
      list4: {
        text1: this.$t("solve.moduleList4.text1"),
        text2: this.$t("solve.moduleList4.text2"),
      },
    };
  },
  computed: {
    cptLanguge() {
      return sessionStorage.getItem("language") || "zh";
    },
  },
};
</script>

<style lang="less" scoped>
.page_box {
  .module_item {
    transition: all 0.5s ease;

    &:hover {
      transform: translateY(-10px);
      transition: all 0.5s ease;
    }
  }

  .module_body_1 {
    text-align: center;
    color: @fontColor6;
    line-height: 30px;

    > img {
      margin-top: 30px;
    }
  }

  .module_body_2 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    // width: 100%;

    .module_item_2 {
      width: 45%;
      display: flex;
      line-height: 25px;
      margin-bottom: 30px;

      .module_item_text {
        color: @fontColor6;
        font-size: 14px;

        .module_item_text_title {
          color: @blackColor;
          font-size: 20px;
        }
      }

      > img {
        height: 34px;
        margin-right: 16px;
      }
    }
  }

  .module_body_3 {
    display: flex;
    justify-content: space-around;
    .module_item_3 {
      text-align: center;
      > img {
        margin-top: 10px;
      }
    }
  }

  .module_body_4 {
    .contact_us_body_email {
      margin-top: 10px;

      > p {
        flex: 1;
        /* width: 50%; */
        text-align: left;
        font-size: 20px;
        color: @blueColor;

        &:first-child {
          flex: 1.3;
          text-align: right;
        }
      }
    }
    .contact_us_body_email_zh {
      > p {
        &:first-child {
          flex: 1;
        }
      }
    }
  }
}
</style>
